var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHko(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hko") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HKO"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.86,79a31.23,31.23,0,1,0-27.51.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.79,69.9a21.74,21.74,0,1,0-21.3.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73,60.77a12.59,12.59,0,1,0-15.43.42"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 72.11,
    y1: 73.84,
    x2: 61.28,
    y2: 66.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 75.8,
    y1: 85.05,
    x2: 59.29,
    y2: 73.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 78.86,
    y1: 94.37,
    x2: 54.84,
    y2: 85.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 47.66,
    y1: 105.55,
    x2: 65,
    y2: 55.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.45,
    y: 105.55,
    width: 47.11,
    height: 4.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.51,51A4.49,4.49,0,1,0,65,46.54,4.49,4.49,0,0,0,60.51,51Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 83.03,
    y1: 105.55,
    x2: 65.69,
    y2: 55.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 58.65,
    y1: 73.84,
    x2: 69.49,
    y2: 66.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 54.97,
    y1: 85.05,
    x2: 71.47,
    y2: 73.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 51.9,
    y1: 94.37,
    x2: 75.93,
    y2: 85.05
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHko);
export default __webpack_public_path__ + "static/media/hko.d2ae0889fae1e75b8e6c26745f0f8278.svg";
export { ForwardRef as ReactComponent };